import React, {useState, useEffect, useContext,lazy,Suspense} from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import NextWeekIcon from '@material-ui/icons/NextWeek';
import Divider from '@material-ui/core/Divider';
import CloseIcon from '@material-ui/icons/Close';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import RPay from '../../../assets/images/R.png';
import MyDailogModal from '../../Commons/myDailogModal';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import Loading from '../../Commons/loading';
import {devConsolelog,  postPrivateApi , WebContext,LoadingComponent} from '../../../Utility';
import {API_DOMAIN_B2B2C, API_SECTION_FLIGHTS, API_SECTION_FLIGHT_VERSION, API_ENDPOINT_FARE_RULES,
  FLIGHTS_AIRLINE_LOGO_BASE_URL} from '../../../Constants';
import {getFlightSegmentFields, getFlightFields, getCabinClassName, getTime,
   getDateAndMonth, StyledTabsForFlights, StyledTabForFlights} from './flightsUtility';
import useStyles from './styles';
import { useTheme } from '@material-ui/core/styles';
import {StyledTypographyBlack} from '../../Commons/styledTabs';


const ReactHtmlParser = lazy(() => import("../../Commons/ReactHtmlParser"));
const ruleData =
  {
    heading: "Provider Cancellation Fee : ",
    item: ["109 for domestic (per person)","218 for international (per person)"],
    item2: "Travel Operator Fee will be added to the above"
  };



const FlightDetails = ({onClose, flightDetail = {}, orgCode=null, isIntReturn,
  traceId, deskTopView, b2b2ctraceId, fareRules=[],showModal=true}) => {
    const theme = useTheme();
  devConsolelog('my detail',flightDetail,fareRules)
  const classes = useStyles();
  let {sg: segments = null, outboundFlight= []} = flightDetail;
  // segments = segments[0] || [];
  if(isIntReturn && !segments && outboundFlight) {
    // handle international return case
    segments = flightDetail['outboundFlight'] || [];
  }
  const { memberCode=null} = useContext(WebContext);
  const FlightsSegmentsItem = ({segmentIndex}) => {
    const [airlineLogo, setAirlineLogo] = useState('');


    const {
      resultIndex = null,
      fare = '',
      airlineName = '',
      airlineCode = '',
      flightNumber = '',
      currency,
      isRefundable,
      duration,
      origin = {},
      destination = {},
      baggage,
      cabinClass,
      cabinBaggage,
      groundTime,
      fareClass,
      stopOver,
      stopPoint,
      stopDuration
    } = getFlightSegmentFields(flightDetail, isIntReturn, segmentIndex);
    let {
      terminal: originTerminal = '',
      cityCode: originCityCode = '',
      cityName: originCityName = '',
      depTime = '',
      originAirport = '',
    } = origin;
    let {
      terminal = '',
      cityCode = '',
      cityName = '',
      arrTime = '',
      airport = ''
    } = destination
    devConsolelog('flights flightDetail ', flightDetail, fare, flightNumber, baggage, originTerminal, duration, terminal);

    useEffect(() => {
      // let airline_logo = '/air_asia.png';
      if(airlineCode) setAirlineLogo(`${FLIGHTS_AIRLINE_LOGO_BASE_URL}${airlineCode}.png`);
      else setAirlineLogo(`${FLIGHTS_AIRLINE_LOGO_BASE_URL}00_nologo.png`)
    }, [airlineCode])

    const handleLogoError = () => setAirlineLogo(`${FLIGHTS_AIRLINE_LOGO_BASE_URL}00_nologo.png`);

    return (
      <div className={classes.mainCardSegment} >
        {
          (segmentIndex > 0) && (
          <Box m={2} className={classes.segmentDivider}>
            <Box></Box>
            <Box display="flex" justifyContent="space-around">
              <StyledTypographyBlack variant="subtitle1" className={classes.secondaryText} style={{textDecoration: 'none'}}>Layover</StyledTypographyBlack>
              <StyledTypographyBlack variant="subtitle1" className={`${classes.secondaryText} ${classes.grountTime}`}>
                {/* <img src='/clock.png' height="16" /> */}
                <AccessTimeIcon style={{width:16 , margin:'0 8px',color:theme?.agentTheme?.primary?.foreground}}/>
                &nbsp;&nbsp;{groundTime}
              </StyledTypographyBlack>
              <StyledTypographyBlack variant="subtitle1" >{originCityCode}</StyledTypographyBlack>
            </Box>
            <Box></Box>
          </Box>
          )
        }

        <Box p={2}><StyledTypographyBlack variant="subtitle2" style={{color:theme?.agentTheme?.text?.small_text_color}}>{originCityName} - {cityName}</StyledTypographyBlack></Box>
        <Box pl={2} pr={2} className={classes.mainBox}>
          <Box className={classes.leftBox}>
            <div>
              <img src={airlineLogo} height='30' width='30' onError={() => handleLogoError()} style={{marginRight:8}}/>
              {deskTopView && <Box mt={1} mb={1} ><StyledTypographyBlack style={{color:theme?.agentTheme?.text?.small_text_color}}>{airlineName}</StyledTypographyBlack></Box>}
              <StyledTypographyBlack variant="subtitle2" className={classes.secondaryText}>{airlineCode} - {flightNumber}{fareClass}</StyledTypographyBlack>
            </div>
            {deskTopView && <StyledTypographyBlack variant="subtitle2" className={classes.secondaryText}>{getCabinClassName(cabinClass)}</StyledTypographyBlack>}
          </Box>
          <Box className={classes.centerBox}>
            <div>
              <StyledTypographyBlack variant="subtitle2" className={classes.secondaryText}>{getDateAndMonth(depTime || null)}</StyledTypographyBlack>
              <StyledTypographyBlack variant="subtitle2" className={classes.secondaryText}>{getDateAndMonth(arrTime || null)}</StyledTypographyBlack>
            </div>
            <div>
              <StyledTypographyBlack variant="h6" style={{color:theme?.agentTheme?.text?.small_text_color}}>{getTime(depTime || null)}</StyledTypographyBlack>
              {deskTopView ? (<><div className={classes.dividerDiv}></div>
                <Box display="flex" alignItems="center">
                  <StyledTypographyBlack variant='subtitle1' style={{color:theme?.agentTheme?.text?.small_text_color}}>{duration}</StyledTypographyBlack>
                </Box>
                <div className={classes.dividerDiv}></div></>) :
                (<Box display='flex' flexDirection='column' alignItems='center' width='100%'>
                  <StyledTypographyBlack variant='subtitle1' className={classes.timeText} style={{fontSize:10,color:theme?.agentTheme?.text?.small_text_color}}>{duration}</StyledTypographyBlack>
                  <div className={classes.dividerDiv}></div>
                  <StyledTypographyBlack variant='caption' style={{fontSize:10,color:theme?.agentTheme?.text?.body_text_color}} >{stopOver ? 'Technical Stop' : 'Non-Stop'}</StyledTypographyBlack>
                </Box>)
                }
              <StyledTypographyBlack variant="h6" style={{color:theme?.agentTheme?.text?.small_text_color}}>{getTime(arrTime || null)}</StyledTypographyBlack>
            </div>
            <div>
              <StyledTypographyBlack variant="subtitle2" style={{color:theme?.agentTheme?.text?.small_text_color}}>{originCityCode || ''}</StyledTypographyBlack>
              {deskTopView && stopOver && <StyledTypographyBlack variant='caption' style={{color:theme?.agentTheme?.text?.small_text_color}}>Technical Stop</StyledTypographyBlack>}
              <StyledTypographyBlack variant="subtitle2" style={{color:theme?.agentTheme?.text?.small_text_color}}>{cityCode || ''}</StyledTypographyBlack>
            </div>
            <div style={{position:'relative'}}>
              <StyledTypographyBlack variant="subtitle2" className={classes.secondaryText} style={{maxWidth: '50%'}}>{originAirport || ''}</StyledTypographyBlack>
              {stopOver && <StyledTypographyBlack variant='caption' className={`${classes.secondaryText} ${classes.techStop}`}>{stopPoint && stopPoint}{stopDuration && ` | ${stopDuration} Mins`}</StyledTypographyBlack>}
              <StyledTypographyBlack variant="subtitle2" className={classes.secondaryText}>{airport || ''}</StyledTypographyBlack>
            </div>
            <div>
              <StyledTypographyBlack variant="subtitle2" style={{color:theme?.agentTheme?.text?.small_text_color}}>{originTerminal ? `Terminal ${originTerminal}` : ''}</StyledTypographyBlack>
              <StyledTypographyBlack variant="subtitle2" style={{color:theme?.agentTheme?.text?.small_text_color}}>{terminal ? `Terminal ${terminal}` : ''}</StyledTypographyBlack>
            </div>
          </Box>
          <div className={classes.rightBoxContainer}>
              {
                cabinBaggage && (<Box className={classes.rightBox}>
                  <div className={classes.rightBoxIcons}>
                    <BusinessCenterIcon fontSize="small" />
                  </div>
                  <div>
                    <StyledTypographyBlack variant="subtitle2" style={{color:theme?.agentTheme?.text?.small_text_color}}>{cabinBaggage}</StyledTypographyBlack>
                    <StyledTypographyBlack variant="subtitle2" className={classes.secondaryText}>Cabin Baggage</StyledTypographyBlack>
                  </div>
                </Box>)
              }
              {
              baggage && (<Box className={classes.rightBox}>
                <div className={classes.rightBoxIcons}>
                  <NextWeekIcon fontSize="small" />
                </div>
                <div>
                  <StyledTypographyBlack variant="subtitle2" style={{color:theme?.agentTheme?.text?.small_text_color}}>{baggage}</StyledTypographyBlack>
                  <StyledTypographyBlack variant="subtitle2" className={classes.secondaryText}>Check-in Baggage</StyledTypographyBlack>
                </div>
              </Box>)
            }
            <Box className={classes.rightBox}>
              <div className={classes.rightBoxIcons}>
                {/* <img className={`${isRefundable ? classes.refundImg : classes.nonRefundImg}`} src='/R.png' height="20px" /> */}
                 {
                  isRefundable ?   <span
  style={{
    display: "inline-block",
    width: 20,
    height: 20,
    backgroundColor: theme?.agentTheme?.success?.main, 
    WebkitMask: `url(${RPay}) no-repeat center / contain`,
    mask: `url(${RPay}) no-repeat center / contain`,
  }}
/>: <span
  style={{
    display: "inline-block",
    width: 20,
    height: 20,
    backgroundColor: theme?.agentTheme?.text?.body_text_color, 
    WebkitMask: `url(${RPay}) no-repeat center / contain`,
    mask: `url(${RPay}) no-repeat center / contain`,
  }}
/>
                 }
                 
              </div>
              <StyledTypographyBlack variant="subtitle2" className={classes.refundableText}>{isRefundable ? 'Refundable' : 'Non-Refundable'}</StyledTypographyBlack>
            </Box>
          </div>
        </Box>
      </div>
    )
  }

  const FlightsSegmentsList = () => {
    return (<>
      {
        segments.map((item, index) => <FlightsSegmentsItem segmentIndex={index} />)
      }

    </>)
  }

  const FareRules = ({fareRule = [], isLoading = false}) => {
    devConsolelog('flights fare rule ', fareRule);
    return(
      <>
        <Box p={1} display='flex' flexDirection='column' alignItems='center'>
          {
            (fareRule || []).map((segmentRule, index) => {
              const { fareRuleDetail='', destination='', origin='' } = segmentRule || {};
              devConsolelog('flights fare rule segment ', segmentRule, fareRuleDetail);
              return (<Box m={1} width="100%">
                <Box p={2}><StyledTypographyBlack variant="subtitle2" style={{color:theme?.agentTheme?.card?.foreground}}>{origin} - {destination}</StyledTypographyBlack></Box>
                {fareRuleDetail ?   <Suspense fallback={<LoadingComponent />}>
<Typography variant="subtitle2" style={{color:theme?.agentTheme?.text?.body_text_color}}><ReactHtmlParser data ={fareRuleDetail || ''} /></Typography> </Suspense> : null}
                {
                  index < (fareRule.length - 1) && (<Box m={2}><Divider classes={{root: classes.segmentDivider}}  style={{ backgroundColor: theme?.agentTheme?.secondary?.light }} /></Box>)
                }

              </Box>
              )
            })
          }

          <Loading isLoading={isLoading} />

        </Box>
       {fareRule && fareRule.length>0 ? <Box>
         <List >
            <ListItem style={{paddingBottom:"0px"}}>
              <StyledTypographyBlack variant='body2' style={{color:theme?.agentTheme?.card?.foreground}}>{ruleData.heading}</StyledTypographyBlack>
            </ListItem>
            {
              ruleData.item.map((item) => (
            <ListItem className={classes.listPadding}>
              <Box my={0.5} pl={7}><StyledTypographyBlack variant='body2' style={{color:theme?.agentTheme?.text?.body_text_color}}>{item}</StyledTypographyBlack></Box>
            </ListItem>
             ))}
            <ListItem style={{ fontStyle:"italic" }} >
              <StyledTypographyBlack variant='body2' style={{color:theme?.agentTheme?.text?.body_text_color}}>{ruleData.item2}</StyledTypographyBlack>
            </ListItem>
         </List>
        </Box> :null}
    </>
    )
  }

  const ModalBody = () => {

    const [tabValue, setTabValue] = useState('Flight Details');

    const {resultIndex=null, origin={}, destination={}} = getFlightFields(flightDetail, isIntReturn);
    const {cityCode:originCityCode=''} = origin;
    const {cityCode=''} = destination;
    // const {traceId=null} = searchMetaData;

    const [isLoading, setIsLoading] = useState(false);
    const [fareRule, setFareRule] = useState(fareRules && fareRules.length>0 ? fareRules : null);

    useEffect(() => {
      if(!resultIndex || !traceId) return;

      const getFareRules = async () => {
        setIsLoading(true);
        const {data = {}, status, err = null} = await postPrivateApi(
          `${API_DOMAIN_B2B2C}${API_SECTION_FLIGHTS}${API_SECTION_FLIGHT_VERSION}${API_ENDPOINT_FARE_RULES}`,
          {
            traceId,
            resultIndex,
            //provider: 'tbo',
            organizationCode: orgCode,
          },
          {
            organizationCode: orgCode,
            memberCode: memberCode,
            b2b2ctraceId
          }
        )

        if(!data || err) {
          // TODO: handle error
          devConsolelog('flights resuts error ', data, err, err.response ? err.response.data : null );
        }

        const { results = []} = data;
        //const { FareRules = [] } = Response;
        // const { fareRuleDetail=null } = fareRule[0] || [];
        setFareRule(results);
        //devConsolelog('flights fare rule get', FareRules);
        setIsLoading(false);
      }
      if(!fareRule) getFareRules();
    },[resultIndex, traceId,orgCode])

    const handleTabChange = (event, newValue) => {
      setTabValue(newValue);
    };

    return(<div style={{position:'relative'}}>
      <StyledTabsForFlights
        value={tabValue}
        onChange={handleTabChange}
        className={classes.tabs}
        // variant="fullWidth"
        
      >
        <StyledTabForFlights key={0} wrapped label='Flight Details' value='Flight Details' className={classes.labelIcon}/>
        <StyledTabForFlights key={1} wrapped label= {`Cancellation Policy(${originCityCode} - ${cityCode})`} value='Cancellation Policy' className={classes.labelIcon}/>
      </StyledTabsForFlights>
      {/* <Divider /> */}
      <Divider style={{ backgroundColor: theme?.agentTheme?.secondary?.main, opacity: 0.2 }} />
      {
        tabValue == 'Flight Details'
        ? <FlightsSegmentsList />
        : <FareRules fareRule={fareRule} isLoading={isLoading} />
      }
      </div>
    )
  }

  return (showModal ? <MyDailogModal
      titleText={<Box display={'flex'} justifyContent={'flex-end'}>
      <CloseIcon onClick={onClose} style={{color:theme?.agentTheme?.secondary?.foreground}}/>
    </Box>}
      titleClass={classes.detailDailogTitle}
      bodyText={
        <ModalBody />
      }
     actions={                       
        []
     }

     openDailog={true}
     onClose={onClose}
     fullScreen={deskTopView ? false : true}
     maxWidth={'md'}
  /> : <ModalBody/>)
}

export default FlightDetails
